import {FC} from 'react'
import HTMLRenderer from 'react-html-renderer'
import './style.css'

type Props = {
  title: string
  value: string
}

const ProposalSummaryContent: FC<Props> = ({title, value}) => {
  return (
    <div className='card'>
      <div className='px-8 py-7'>
        <div className='d-flex align-items-center gap-3'>
          <p className='fs-4 fw-bold'>{title ?? ''}</p>
        </div>
      </div>
      <div className='px-8 pb-8'>
        <div className='p-5 border rounded-top' style={{backgroundColor: '#F4F7FE'}}>
          <p>Ringkasan</p>
        </div>
        <div className='border rounded-bottom ql-editor'>
          <HTMLRenderer html={value ?? ''} />
        </div>
      </div>
    </div>
  )
}

const ProposalSummary: FC<Props> = ({title, value}) => {
  return <ProposalSummaryContent title={title} value={value} />
}

export default ProposalSummary
